import interpolate from '@/lib/interpolate';

let alternativeCount = 0;

export function nextAlternativeId() {
  alternativeCount += 1;

  return `map-alternative-${alternativeCount}`;
}

export function parseA11yLabels(dataset, context) {
  try {
    return JSON.parse(dataset.a11y || '{}');
  } catch (error) {
    // Thrown before app.mount(), this would leave the whole page blank.
    if (window.Sentry) {
      window.Sentry.captureException(error, { extra: { context } });
    }

    return {};
  }
}

export function pluralize(forms, count, values = {}) {
  const { zero, one, other } = forms || {};
  const template = (count === 0 && zero) || (count === 1 && one) || other;

  return interpolate(template, { count, ...values });
}

// A missing label leaves either a nameless application region or, worse, a control the
// region made necessary with no accessible name at all: report it rather than ship it.
export function reportMissingLabels(labels, keys, context) {
  const missing = keys.filter(
    key => !key.split('.').reduce((value, part) => value?.[part], labels),
  );

  if (missing.length === 0) return;

  if (window.Sentry) {
    window.Sentry.captureMessage('Missing accessibility labels', {
      level: 'warning',
      extra: { context, missing },
    });
  }
}
